import React from "react";

export default function EmptyState({
  title,
  message,
  hint,
  icon = "📭",
  testId = "empty-state",
}) {
  return (
    <div className="card p-5 text-center" data-testid={testId}>
      <div className="text-3xl" aria-hidden="true">
        {icon}
      </div>
      <p className="mt-3 text-base font-semibold text-slate-900">{title}</p>
      <p className="mt-1 text-sm text-slate-600">{message}</p>
      {hint && <p className="mt-2 text-xs text-slate-400">{hint}</p>}
    </div>
  );
}
